<template>
    <div class="p-6 rounded-md bg-slate-50 dark:bg-slate-700 leading-tight">
        <div class="relative">
            <div v-if="loading"
                  class="absolute text-slate-700 text-sm dark:text-white flex items-center justify-center inset-0 z-30 bg-white/30 dark:bg-slate-800/30">
                <div>Подождите</div>
            </div>
            <div v-if="data" class="text-xl font-black mb-4">
                {{ data.header }}
            </div>

            <div v-if="data && showResults" class="space-y-1">
                <div v-for="result in data.variants" :key="result.id" class="p-2 px-3">
                    <div class="flex space-x-1 justify-between mb-1">
                        <div class="flex items-center space-x-4">
                            <div>{{ result.label }}</div>
                            <div class="text-gray-500 dark:text-gray-300 text-sm">
                                {{percent(result.votes_count) }}%
                            </div>
                        </div>
                        <div class="flex space-x-2 items-center">
							<svg-icon v-if="userVotedForThisVariant(result.id)"
									  icon="check-lg"
									  class="text-orange w-5 h-5 shrink-0"
							></svg-icon>
                            <div class="text-sm">{{ result.votes_count }}</div>
                        </div>
                    </div>
                    <div class="bg-biege rounded dark:bg-slate-500">
                        <div class="h-1 rounded bg-orange" :style="'width:' + percent(result.votes_count) + '%'"></div>
                    </div>
                </div>
            </div>
			<div v-if="user.check() && data && !voted" class="space-y-2">
                <div v-for="variant in data.variants" :key="variant.id"
                     @click="select(variant)"
                     class="rounded shrink-0 flex space-x-2 items-start p-2 px-3 text-sm cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-600">
					<div v-if="data?.multiple"
						 class="rounded inline-flex items-center justify-center border-2 mt-0.5 border-orange bg-white w-4 h-4 shrink-0">
						<div v-if="isSelectedVariant(variant.id)" class="w-1.5 h-1.5 bg-orange rounded-sm"></div>
					</div>
					<div v-else class="rounded-full border-2 mt-0.5 border-orange bg-white w-4 h-4 shrink-0"></div>
					<div>
						{{ variant.label }}
					</div>
                </div>
				<div v-if="data?.multiple && variants.length > 0" class="pl-3">
					<div @click.prevent="send" class="btn btn-orange btn-sm cursor-pointer">
						Проголосовать
					</div>
				</div>
            </div>

			<div v-if="user.check() && !voted" class="mt-4 px-3">
                <div @click="markVoted"
                     class="inline-flex cursor-pointer items-center space-x-1 text-sm text-gray-500 dark:text-gray-300">
                    <svg-icon icon="bar-chart-fill" class="w-3 h-3"></svg-icon>
                    <div>Показать результаты</div>
                </div>
            </div>

            <div class="mt-4 px-3">
				<div v-if="user.check() && voted" @click="reset"
                     class="inline-flex cursor-pointer items-center space-x-1 text-sm text-gray-500 dark:text-gray-300">
                    <svg-icon icon="arrow-clockwise" class="h-4 w-4"></svg-icon>
                    <div>Переголосовать</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Client from "../../js/modules/Client";
import {notify} from "@kyvg/vue3-notification";
import User from "../../js/modules/User";

export default {
    props: [
        'id',
    ],
    data() {
        return {
            data: this.poll,
            loading: false,
            user: new User(),
			variants: [],
        }
    },
    mounted() {
        this.loading = true;
        Client.get('/api/v1.1/poll/' + this.id).then(response => {
            this.data = response.data.data;
            this.loading = false;
        }).catch(error => {
            notify({
                type: 'error',
                text: 'Ошибка голосования',
            });
        })
    },
    methods: {
        select(variant) {
			this.toggleSelectedVariant(variant.id)

			if (!this.data.multiple) {
				this.send();
			}
        },
		toggleSelectedVariant(variant_id) {
			const index = this.variants.indexOf(variant_id);

			if (index === -1) {
				this.variants.push(variant_id);
			} else {
				this.variants.splice(index, 1);
			}
		},
		isSelectedVariant(variant_id) {
			return this.variants.indexOf(variant_id) !== -1
		},
		send() {
			this.loading = true;
			Client.post('/api/v1.1/poll/' + this.id, {
				variants: this.variants,
			}).then(response => {
				this.data = response.data.data;
				this.loading = false;
			}).catch(error => {
				notify({
					type: 'error',
					text: 'Ошибка голосования',
				});
			})
		},
		userVotedForThisVariant(variant_id) {
			const index = this.data?.voted.indexOf(variant_id);
			return index !== -1;
		},
        markVoted() {
			this.data.voted = ['empty'];
        },
        reset() {
			this.data.voted = [];
			this.variants = [];
        },
        total() {
            let total = 0;
            this.data.variants.forEach(result => {
                total += result.votes_count;
            })

            return total;
        },
        percent(value) {
            let total = this.total();

			return total ? Math.round(value / total * 100) : 0;
        }
    },
    computed: {
        showResults() {
			return this.data?.voted?.length || this.user.guest();
		},
		voted() {
			return this.data?.voted?.length > 0;
		}
    }
}
</script>
